import React from "react";
import { AppBar, Box, Button, Toolbar, Typography, Container } from "@mui/material";

const Header = () => {
	return (
		<Box>
			{/* Main Header */}
			<AppBar position="static">
				<Container maxWidth="lg">
					<Toolbar sx={{ py: 1 }}>
						<Box>
							<Typography variant="h5" sx={{ fontWeight: 600 }}>
								Hajj 2026 Package Explorer
							</Typography>
							<Typography variant="subtitle2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
								Your Journey to the Holy Land
							</Typography>
						</Box>
					</Toolbar>
				</Container>
			</AppBar>

			{/* Hero Section */}
			<Box sx={{ py: 2, textAlign: 'center', backgroundColor: '#f5f5f5', borderBottom: '1px solid rgba(0,35,102,0.3)' }}>
				<Container maxWidth="md">
					<Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
						<a
							href="/Hajj Packages 2026 - Phase 2.xlsx"
							download="Hajj Packages 2026 - Phase 2.xlsx"
							style={{ textDecoration: 'none' }}
						>
							<Button variant="contained" color="primary" size="small">
								Download excel
							</Button>
						</a>
						<Typography variant="body2" sx={{ color: '#666', fontSize: '0.8rem' }}>
							Packages data loaded from Nusuk Hajj website - Last updated: 15-Feb-2026
						</Typography>
						<Typography variant="body2" sx={{ color: '#666', fontSize: '0.8rem' }}>
							Data was scraped using a UK pilgrim profile; availability may differ by country quota.
						</Typography>
						<Box sx={{ mt: 1, px: 2, py: 0.75, bgcolor: '#fff8e1', borderRadius: 1, border: '1px solid #ffe082' }}>
							<Typography variant="body2" sx={{ color: '#6d4c00', fontSize: '0.8rem' }}>
								Nusuk Hajj updates package details regularly. If you notice any discrepancy in the data, please let us know at{' '}
								<a href="mailto:rli2pbaho@mozmail.com" style={{ color: '#1565c0', fontWeight: 500 }}>rli2pbaho@mozmail.com</a>
							</Typography>
						</Box>
					</Box>
				</Container>
			</Box>
		</Box>
	);
};

export default Header;
